import { gql } from '@src/__generated__';

const REPORTS_QUERY_WITHOUT_COLLECTIONS = gql(/* GraphQL */ `
  query getReportsWithoutCollections {
    reports: objects(
      filter: {
        schemaTags: { contains: ["application", "board", "report"] }
        objectsToObjectsByObject1IdConnection: {
          every: { object2: { not: { schemaTags: { contains: ["collection"] } } } }
        }
      }
      orderBy: NAME_ASC
    ) {
      id
      name
      schemaTags
      ...AccessGroupsFragment
    }
  }
`);

export { REPORTS_QUERY_WITHOUT_COLLECTIONS };
